import sidebardashboardimg from "../../assets/img/SideBarImage/DashBoard.png";
import LeadsImg from "../../assets/img/SideBarImage/Leads.png";
import fileLoginImg from "../../assets/img/SideBarImage/FileLogin.png";
import CollectionOfIMD from "../../assets/img/SideBarImage/CollectionIME.png";
import OTCClearanceimg from "../../assets/img/SideBarImage/OTC.png";
import CollectionOfEmi from "../../assets/img/SideBarImage/CollectionIME.png";
import channelPartnerImg from "../../assets/img/SideBarImage/ChannelPartner.png";
import MarketingImg from "../../assets/img/SideBarImage/MarketingActivity.png";
import AuthorityVisitImg from "../../assets/img/SideBarImage/Authority.png";
import DeskWordImg from "../../assets/img/SideBarImage/Deskwork.png";
import buisnessImg from "../../assets/img/SideBarImage/Business.png";
import ResidenceImg from "../../assets/img/SideBarImage/Residence.png";
import GeneralImg from "../../assets/img/SideBarImage/General.png";
import BranchClosingImg from "../../assets/img/SideBarImage/BranchClosing.png";
import BranchOpeningImg from "../../assets/img/SideBarImage/BranchOpening.png";
import PropertyImg from "../../assets/img/SideBarImage/Property.png";
import DocumentCollectionImg from "../../assets/img/SideBarImage/DocumentsCollection.png";
import BankVisitImg from "../../assets/img/SideBarImage/BankVisit.png";
import CustomerVisitImg from "../../assets/img/SideBarImage/Customer.png";
import BtBankVisitImg from "../../assets/img/SideBarImage/BT BANK.png";
import VendorVisitImg from "../../assets/img/SideBarImage/Vendor.png";
import BrokerVisitImg from "../../assets/img/SideBarImage/BankVisit.png";
import TeamsImg from "../../assets/img/SideBarImage/team.png";
import EmployeeIcon from "../../assets/img/SideBarImage/EmployeeIcon.png";
import FeedbackImg from "../../assets/img/SideBarImage/feedback.png";
import FolderImg from "../../assets/img/SideBarImage/folder.png";
import FileMovement from "../../assets/img/SideBarImage/filemovement.png";
import InventoryImg from "../../assets/img/SideBarImage/inventory.png";
import BranchIssueImg from "../../assets/img/SideBarImage/branchissue.png";
import BranchAssetsImg from "../../assets/img/SideBarImage/branchassets.png";
import TargetImg from "../../assets/img/SideBarImage/target.png"
import BranchImg from "../../assets/img/SideBarImage/branch.png"
import LoanImg from "../../assets/img/SideBarImage/loan.png"
import PerformanceImg from "../../assets/img/SideBarImage/performance.png"
import BranchTargetImg from "../../assets/img/SideBarImage/branchtarget.png"
import EmployeeAssignmentImg from "../../assets/img/SideBarImage/division.png"
import ActivityImg from "../../assets/img/SideBarImage/activity.png"
// --- Role Helpers ---

const hasRole = (roleName) => {
  try {
    const userStr = sessionStorage.getItem("user");
    if (!userStr) return false;
    const user = JSON.parse(userStr);
    return user?.roles?.includes(roleName) || false;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return false;
  }
};

const isSuperAdmin = () => hasRole("SuperAdmin");

// Helper function to filter menu items based on user role
const getFilteredMainMenu = (baseMenu) => {
  return baseMenu.filter((item) => {
    if (
      item.menuValue === "Employee" ||
      item.menuValue === "Branch" ||
      item.menuValue === "Target Management" ||
      item.menuValue === "Branch Targets Management" ||
      item.menuValue === "Employee Branch Assignment" ||
      item.menuValue === "Excluded Loans"
    ) {
      return isSuperAdmin();
    }
    return true;
  });
};

// Base main menu template
const getBaseMainMenu = () => [
  {
    menuValue: "Dashboard",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/employee-dashboard",
    icon: sidebardashboardimg,
  },
  {
    menuValue: "Employee",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/employee-data",
    icon: EmployeeIcon,
  },
  {
    menuValue: "Branch",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/branch-master",
    icon: BranchImg,
  },
  {
    menuValue: "Target Management",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/target-management",
    icon: TargetImg,
  },
  {
    menuValue: "Branch Targets Management",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/branch-target",
    icon: BranchTargetImg,
  },
  {
    menuValue: "Employee Branch Assignment",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/employee-assignment",
    icon: EmployeeAssignmentImg,
  },
  {
    menuValue: "Excluded Loans",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/excluded-loans",
    icon: LoanImg,
  },

  {
    menuValue: "My Performance",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/my-target-performance",
    icon: PerformanceImg,
  },
   {
    menuValue: "Activities",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/Check-activities",
    icon: ActivityImg,
  },
  {
    menuValue: "Teams",
    hasSubRoute: false,
    showSubRoute: false,
    route: "/teams",
    icon: TeamsImg,
  },
];

export const getCollectionData = () => [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: getFilteredMainMenu(getBaseMainMenu()),
  },
  {
    tittle: "COLLECTION",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Collection Visit", hasSubRoute: false, showSubRoute: false, route: "/collection-visit", icon: CollectionOfEmi },
      { menuValue: "Authority Visit", hasSubRoute: false, showSubRoute: false, route: "/authority-visit", icon: AuthorityVisitImg },
      { menuValue: "Property Visit", hasSubRoute: false, showSubRoute: false, route: "/property-visit", icon: PropertyImg },
      { menuValue: "Broker Visit", hasSubRoute: false, showSubRoute: false, route: "/broker-visit", icon: BrokerVisitImg },
      { menuValue: "Desk Work", hasSubRoute: false, showSubRoute: false, route: "/desk-work", icon: DeskWordImg },
      { menuValue: "Pre-Disbursal Collection Visit", hasSubRoute: false, showSubRoute: false, route: "/pre-disbursal-collection-visit", icon: DeskWordImg },
    ],
  },
];

export const getSalesData = () => [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: [
      ...getFilteredMainMenu(getBaseMainMenu()),
      {
        menuValue: "Reports",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "la la-chart-pie",
        subMenus: [
          { menuValue: "Activity Report", route: "/activity-reports" },
          { menuValue: "Team Report", route: "/team-reports" },
          { menuValue: "Employee Report", route: "/employee-reports" },
        ],
      },
    ],
  },
  {
    tittle: "SALES",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Leads", hasSubRoute: false, showSubRoute: false, route: "/leads-list", icon: LeadsImg },
      { menuValue: "File Login", hasSubRoute: false, showSubRoute: false, route: "/file-login", icon: fileLoginImg },
      { menuValue: "Collection of IMD", hasSubRoute: false, showSubRoute: false, route: "/imdcollection", icon: CollectionOfIMD },
      { menuValue: "OTC Clearance", hasSubRoute: false, showSubRoute: false, route: "/otc-clearance", icon: OTCClearanceimg },
      { menuValue: "Collection of EMI", hasSubRoute: false, showSubRoute: false, route: "/collection", icon: CollectionOfEmi },
      { menuValue: "Channel Partner Visit", hasSubRoute: false, showSubRoute: false, route: "/channel-partners", icon: channelPartnerImg },
      { menuValue: "Marketing Activity", hasSubRoute: false, showSubRoute: false, route: "/marketing-activity", icon: MarketingImg },
      { menuValue: "Authority Visit", hasSubRoute: false, showSubRoute: false, route: "/authority-visit", icon: AuthorityVisitImg },
      { menuValue: "Desk Work", hasSubRoute: false, showSubRoute: false, route: "/desk-work", icon: DeskWordImg },
      { menuValue: "Branch Closing", hasSubRoute: false, showSubRoute: false, route: "/branch-closing", icon: BranchClosingImg },
      { menuValue: "Branch Opening", hasSubRoute: false, showSubRoute: false, route: "/branch-opening", icon: BranchOpeningImg },
      { menuValue: "Customer Feedback", hasSubRoute: false, showSubRoute: false, route: "/customer-feedback", icon: FeedbackImg },
    ],
  },
];

export const getTechnicalData = () => [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: getFilteredMainMenu(getBaseMainMenu()),
  },
  {
    tittle: "TECHNICAL",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Property Visit", hasSubRoute: false, showSubRoute: false, route: "/property-visit", icon: PropertyImg },
      { menuValue: "Vendor Visit", hasSubRoute: false, showSubRoute: false, route: "/vendor-visit", icon: VendorVisitImg },
      { menuValue: "Authority Visit", hasSubRoute: false, showSubRoute: false, route: "/authority-visit", icon: AuthorityVisitImg },
      { menuValue: "Desk Work", hasSubRoute: false, showSubRoute: false, route: "/desk-work", icon: DeskWordImg },
    ],
  },
];

export const getCreditData = () => [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: getFilteredMainMenu(getBaseMainMenu()),
  },
  {
    tittle: "CREDIT",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Business PD", hasSubRoute: false, showSubRoute: false, route: "/buisness-pd", icon: buisnessImg },
      { menuValue: "Residence PD", hasSubRoute: false, showSubRoute: false, route: "/residense-pd", icon: ResidenceImg },
      { menuValue: "General PD", hasSubRoute: false, showSubRoute: false, route: "/general-pd", icon: GeneralImg },
      { menuValue: "Property Visit", hasSubRoute: false, showSubRoute: false, route: "/property-visit", icon: PropertyImg },
      { menuValue: "Document Collection", hasSubRoute: false, showSubRoute: false, route: "/document-collection", icon: DocumentCollectionImg },
      { menuValue: "Collection Visit", hasSubRoute: false, showSubRoute: false, route: "/collection-visit", icon: CollectionOfEmi },
      { menuValue: "Collection of EMI", hasSubRoute: false, showSubRoute: false, route: "/collection", icon: CollectionOfEmi },
      { menuValue: "Desk Work", hasSubRoute: false, showSubRoute: false, route: "/desk-work", icon: DeskWordImg },
      { menuValue: "Branch Closing", hasSubRoute: false, showSubRoute: false, route: "/branch-closing", icon: BranchClosingImg },
      { menuValue: "Branch Opening", hasSubRoute: false, showSubRoute: false, route: "/branch-opening", icon: BranchOpeningImg },
    ],
  },
];

export const getFCUData = () => [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: getFilteredMainMenu(getBaseMainMenu()),
  },
  {
    tittle: "FCU",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Bank Visit", hasSubRoute: false, showSubRoute: false, route: "/bank", icon: BankVisitImg },
      { menuValue: "Property Visit", hasSubRoute: false, showSubRoute: false, route: "/property-visit", icon: PropertyImg },
      { menuValue: "Vendor Visit", hasSubRoute: false, showSubRoute: false, route: "/vendor-visit", icon: VendorVisitImg },
      { menuValue: "Authority Visit", hasSubRoute: false, showSubRoute: false, route: "/authority-visit", icon: AuthorityVisitImg },
      { menuValue: "Customer Visit", hasSubRoute: false, showSubRoute: false, route: "/customer", icon: CustomerVisitImg },
      { menuValue: "Collection Visit", hasSubRoute: false, showSubRoute: false, route: "/collection-visit", icon: CollectionOfEmi },
      { menuValue: "Desk Work", hasSubRoute: false, showSubRoute: false, route: "/desk-work", icon: DeskWordImg },
    ],
  },
];

export const getLegalData = () => [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: getFilteredMainMenu(getBaseMainMenu()),
  },
  {
    tittle: "LEGAL",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Property Visit", hasSubRoute: false, showSubRoute: false, route: "/property-visit", icon: PropertyImg },
      { menuValue: "Collection Visit", hasSubRoute: false, showSubRoute: false, route: "/collection-visit", icon: CollectionOfEmi },
      { menuValue: "Authority Visit", hasSubRoute: false, showSubRoute: false, route: "/authority-visit", icon: AuthorityVisitImg },
      { menuValue: "BT Bank Visit", hasSubRoute: false, showSubRoute: false, route: "/bt-bank-visit", icon: BtBankVisitImg },
      { menuValue: "Vendor Visit", hasSubRoute: false, showSubRoute: false, route: "/vendor-visit", icon: VendorVisitImg },
      { menuValue: "Customer Visit", hasSubRoute: false, showSubRoute: false, route: "/customer", icon: CustomerVisitImg },
      { menuValue: "Desk Work", hasSubRoute: false, showSubRoute: false, route: "/desk-work", icon: DeskWordImg },
    ],
  },
];

export const getCCUData = () => [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Dashboard", hasSubRoute: false, showSubRoute: false, route: "/employee-dashboard", icon: sidebardashboardimg },
    ],
  },
  {
    tittle: "CCU",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Business PD", hasSubRoute: false, showSubRoute: false, route: "/buisness-pd", icon: buisnessImg },
      { menuValue: "Residence PD", hasSubRoute: false, showSubRoute: false, route: "/residense-pd", icon: ResidenceImg },
    ],
  },
];

export const getOperationData = () => {
  const isCentralOp = hasRole("CentralOperation");

  return [
    {
      tittle: "MAIN",
      showAsTab: false,
      separateRoute: false,
      menu: getFilteredMainMenu(getBaseMainMenu()),
    },
    {
      tittle: "OPERATION",
      showAsTab: false,
      separateRoute: false,
      menu: [
        // { menuValue: "Bank Visit", hasSubRoute: false, showSubRoute: false, route: "/bank", icon: BankVisitImg },
        // { menuValue: "Authority Visit", hasSubRoute: false, showSubRoute: false, route: "/authority-visit", icon: AuthorityVisitImg },
        // { menuValue: "Customer Visit", hasSubRoute: false, showSubRoute: false, route: "/customer", icon: CustomerVisitImg },
        // { menuValue: "BT Bank Visit", hasSubRoute: false, showSubRoute: false, route: "/bt-bank-visit", icon: BtBankVisitImg },
        // { menuValue: "Desk Work", hasSubRoute: false, showSubRoute: false, route: "/desk-work", icon: DeskWordImg },
        { menuValue: "Branch Closing", hasSubRoute: false, showSubRoute: false, route: "/branch-closing", icon: BranchClosingImg },
        { menuValue: "Branch Opening", hasSubRoute: false, showSubRoute: false, route: "/branch-opening", icon: BranchOpeningImg },
        { menuValue: "Customer Feedback", hasSubRoute: false, showSubRoute: false, route: "/customer-feedback", icon: FeedbackImg },
        { menuValue: "Branch File Movement", hasSubRoute: false, showSubRoute: false, route: "/file-storage", icon: FolderImg },
        // Use spread to conditionally add the item
        ...(isCentralOp
          ? [
              {
                menuValue: "COPS File Movement",
                hasSubRoute: false,
                showSubRoute: false,
                route: "/file-movement",
                icon: FileMovement,
              },
            ]
          : []),
      ],
    },
  ];
};

export const getITData = () => [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: getFilteredMainMenu(getBaseMainMenu()),
  },
  {
    tittle: "IT",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "IT Inventory", hasSubRoute: false, showSubRoute: false, route: "/it-inventory", icon: InventoryImg },
      { menuValue: "Branch Issue", hasSubRoute: false, showSubRoute: false, route: "/branch-issue", icon: BranchIssueImg },
      { menuValue: "Branch Assets", hasSubRoute: false, showSubRoute: false, route: "/branch-assets", icon: BranchAssetsImg },
    ],
  },
];

export const getHRData = () => [
  {
    tittle: "HR",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Employee Grievances", hasSubRoute: false, showSubRoute: false, route: "/employee-grievances", icon: FeedbackImg },
    ],
  },
];

export const getExcludedLoansData = () => [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: getFilteredMainMenu(getBaseMainMenu()),
  },
  {
    tittle: "EXCLUDED LOANS",
    showAsTab: false,
    separateRoute: false,
    menu: [
      { menuValue: "Excluded Loans", hasSubRoute: false, showSubRoute: false, route: "/excluded-loans", icon: ActivityImg },
    ],
  },
];

// --- Static Exports ---
export const CollectionData = getCollectionData();
export const SalesData = getSalesData();
export const TechnicalData = getTechnicalData();
export const CreditData = getCreditData();
export const FCUData = getFCUData();
export const LegalData = getLegalData();
export const CCUData = getCCUData();
export const OpertaionData = getOperationData();
export const ITData = getITData();
export const HRData = getHRData();
export const ExcludedLoansData = getExcludedLoansData();